/* TODO: If the cards are all in reviewing stage, the system should
         take that fact into account when showing the graph
*/
import { useRef, useState } from "react";
import CTAButton from "../CTAButton/CTAButton";
import FoldedPopup from "../FoldedPopup/FoldedPopup";
import PlusIcon from "../PlusIcon/PlusIcon";
import { Slider, ThemeProvider, createTheme } from "@mui/material";
import ReactGA from "react-ga4";
import "./CustomSchedulePopup.scss";
import WhiteButton from "../WhiteButton/WhiteButton";
import { MultipleLineChart } from "../MultipleLineChart/MultipleLineChart";
import { useEffect } from "react";
import Sparkles from "react-sparkle";
import ScheduleItem from "../ScheduleItem/ScheduleItem";
import { useNavigate } from "react-router-dom";
import { create_study_plan } from "../../network/communication";

function CustomSchedulePopup(props) {
  const navigate = useNavigate();

  const customSchedulePopupEnabled = props.customSchedulePopupEnabled;
  const setCustomSchedulePopupEnabled = props.setCustomSchedulePopupEnabled;

  const superLearningPathButton = useRef(null);

  const [testDatePopupEnabled, setTestDatePopupEnabled] = useState(true);
  const [howOftenPopup, setHowOftenPopup] = useState(false);
  const [learningPathPopup, setLearningPathPopup] = useState(false);
  const [scheduleReadyPopup, setScheduleReadyPopup] = useState(false);
  const [oftenSliderValue, setOftenSliderValue] = useState(0);
  const [oftenSliderLabel, setOftenSliderLabel] = useState("Slow");
  const [learningSpeed, setLearningSpeed] = useState(1);

  const totalTerms = props.term_count; // Initialize this with the total number of terms in the set.
  const [daysTo100, setDaysTo100] = useState(null);
  const [daysTo100QuizzyPlus, setDaysTo100QuizzyPlus] = useState(null);
  const [activeLearningPath, setActiveLearningPath] = useState(0);

  const user = props.user;
  const setid = props.setid;
  const QUIZZY_PLUS_PREMIUM_MIN_DAYS_BEFORE_TEST = 5;
  const BASIC_MIN_DAYS_BEFORE_TEST = 10;
  const lrm_data = props.lrm_data;

  const theme = createTheme({
    palette: {
      primary: {
        main: "#8358E8",
      },
    },
  });

  var [todayISO] = new Date().toISOString().split("T");
  var today = new Date();
  var minimumDaysBeforeTest = new Date(today);
  minimumDaysBeforeTest.setDate(
    minimumDaysBeforeTest.getDate() +
      (user.membership > 2
        ? QUIZZY_PLUS_PREMIUM_MIN_DAYS_BEFORE_TEST
        : BASIC_MIN_DAYS_BEFORE_TEST)
  ); // Add 3 days to the current date
  var [minimumDaysBeforeTestISO] = minimumDaysBeforeTest
    .toISOString()
    .split("T");

  const maxTermsPerDay = totalTerms;
  const [testDate, setTestDate] = useState(minimumDaysBeforeTestISO);

  const marks = [
    {
      value: 0,
      //label: "Not very often",
    },
    {
      value: 33,
      //label: "Often",
    },
    {
      value: 66,
      //label: "Very often",
    },
    {
      value: 100,
      //label: "Extremely often",
    },
  ];

  const [projectedProgress, setProjectedProgress] = useState({
    fill: [],
    labels: [],
  });

  const getStartingPhase = () => {
    if (lrm_data[0] === 0) {
      // No learning cards
      return "reviewing";
    }
    return "learning";
  };

  const getStartingProgress = () => {
    let totalTerms = lrm_data[0] + lrm_data[1] + lrm_data[2];

    return (lrm_data[1] * 0.5) / totalTerms + lrm_data[2] / totalTerms;
  };

  // Generate a list of dates between the current date and the day after the test date.
  const generateDateRange = (startDate, endDate) => {
    let dates = [];
    let current = new Date(startDate);
    endDate = new Date(endDate);
    endDate.setDate(endDate.getDate() + 1); // add one day to the end date

    while (current <= endDate) {
      dates.push(`${current.getMonth() + 1}/${current.getDate()}`);
      current = new Date(
        current.getFullYear(),
        current.getMonth(),
        current.getDate() + 1
      );
    }

    return dates;
  };
  const generateProgressData = (startDate, endDate, speed, totalTerms) => {
    let numDays = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
    let progress = [];
    const startingProgress = getStartingProgress() * 100;

    let lastProgress = startingProgress; // Initialize lastProgress with the startingProgress value
    progress.push(startingProgress); // Initialize the progress array with the startingProgress value

    for (let i = 1; i < numDays; i++) {
      // Starting from 1 as we have already initialized progress for day 0
      let expectedProgress = Math.min(
        (totalTerms * Math.pow((i + 1) * speed, 1)) / Math.pow(totalTerms, 1),
        totalTerms
      );

      let progressPercentage = Math.min(
        lastProgress + (expectedProgress / totalTerms) * (100 - lastProgress),
        100
      );

      lastProgress = progressPercentage;
      progress.push(progressPercentage);
    }
    return progress;
  };

  const getEndText = function () {
    const startingPhase = getStartingPhase();
    if (startingPhase === "reviewing") {
      if (activeLearningPath === 1) {
        return "Keep up the good work! Continue with your Recall Session and review challenging terms in a Quiz in two days. We'll adjust as you improve.";
      } else {
        return "Great progress so far! Continue with your Recall Session and as you study, we'll fine-tune your learning pace for optimal test prep.";
      }
    }
    if (activeLearningPath === 1) {
      return "Kick off with a Recall Session to check what you know! In two days, try a Quiz on all terms. We'll tweak your learning speed as you progress for the test. Keep going! ";
    } else {
      return "Start with a Recall Session, so we can see what you already know. We'll adjust your learning speed as you recall more to best prepare you for the test.";
    }
  };

  useEffect(() => {
    // This function will calculate the number of days to reach 100% progress
    const calculateDaysTo100 = (totalTerms, learningSpeed) => {
      let day = 0;
      // Calculate the delay based on the learning speed
      let delay = learningSpeed <= 2 ? 3 : 2;
      while (day < totalTerms) {
        if (day < delay) {
          day++;
          continue; // No progress during the delay period
        }
        let expectedProgress =
          (totalTerms * Math.pow((day + 1 - delay) * learningSpeed, 1)) /
          Math.pow(totalTerms, 1);
        if (expectedProgress >= totalTerms) {
          break;
        }
        day++;
      }
      return day;
    };
    // This function will calculate the number of days to reach 100% progress with maximum learning speed
    const calculateDaysTo100WithMaxSpeed = (totalTerms, maxTermsPerDay) => {
      return calculateDaysTo100(totalTerms, 4, maxTermsPerDay); // 4 is maximum learning speed
    };

    if (testDate) {
      // Explicitly set the time to midnight

      let startDate = new Date();
      startDate.setHours(0, 0, 0, 0);

      let endDate = new Date(`${testDate}T00:00:00`);
      endDate.setDate(endDate.getDate()); // Add one day to the end date

      let dateRange = generateDateRange(startDate, endDate);

      const projectedProgressData = generateProgressData(
        startDate,
        endDate,
        learningSpeed,
        totalTerms
      );
      const projectedProgressQuizzyPlusData = generateProgressData(
        startDate,
        endDate,
        4,
        totalTerms
      );

      const daysTo100 = calculateDaysTo100(totalTerms, learningSpeed);

      // Ensure testDate is in a recognized format, e.g., 'YYYY-MM-DD'
      const testDate_DateType = endDate;

      const testDateLabelFormatted = `${
        testDate_DateType.getMonth() + 1
      }/${testDate_DateType.getDate()}`;

      // Calculate the day after the test date
      const testDateNextDay = new Date(testDate_DateType);
      testDateNextDay.setDate(testDateNextDay.getDate() + 1);

      // Calculate Crunch Time start date
      const crunchTimeStart = new Date(testDate_DateType);
      crunchTimeStart.setDate(crunchTimeStart.getDate() - 3);
      const crunchTimeLabelFormatted = `${
        crunchTimeStart.getMonth() + 1
      }/${crunchTimeStart.getDate()}`;

      // Find the index where the learning period ends (i.e., progress reaches 50%)
      let learningEndIndex = projectedProgressData.findIndex(
        (value) => value >= 50
      );
      // If there is no such value in the projectedProgressData, set the learningEndIndex to 0
      if (learningEndIndex === -1) learningEndIndex = 0;
      let learningEndLabelFormatted = dateRange[learningEndIndex];

      const learningPhase = getStartingPhase();

      if (scheduleReadyPopup) {
        // Create a new data point for "Your Progress" at the current date.
        const yourProgressData = new Array(dateRange.length).fill(null);
        yourProgressData[0] = 0; // The progress starts at 0.

        setProjectedProgress({
          fill: [
            {
              title: "Your Progress",
              data: yourProgressData,
              color: "#7B7B7B",
            },
            {
              title: "Projected Progress",
              data: projectedProgressData,
              color: "#8358E8",
              borderDash: [20, 20], // Add the dashed line style
            },
          ],
          labels: dateRange,
          annotations: {
            ...(learningPhase === "learning"
              ? {
                  learning: {
                    type: "box",
                    xMin: `${startDate.getMonth() + 1}/${startDate.getDate()}`,
                    xMax: learningEndLabelFormatted,
                    yMin: 0,
                    yMax: "max",
                    backgroundColor: "rgba(88, 232, 146, 0.5)",
                    label: {
                      display: true,
                      content: "Learning",
                      color: "white",
                      backgroundColor: "rgba(88, 232, 146, 0.5)",
                      font: {
                        family: "Plus Jakarta Sans",
                        weight: 600,
                        size: 16,
                      },
                    },
                  },
                }
              : {}),

            test_date: {
              type: "line",
              xMin: testDateLabelFormatted,
              xMax: testDateLabelFormatted,
              yMin: 0,
              yMax: "max",
              backgroundColor: "rgba(255, 91, 145, 0.5)",
              borderColor: "rgba(255, 91, 145, 0.5)", // Red color for Test Date
              label: {
                display: true,
                content: `Test Date`,
                backgroundColor: "rgba(255, 91, 145, 0.5)",
                xAdjust: -30, // Adjust along x-axis to prevent overlap
                yAdjust: 15, // Adjust along y-axis to prevent overlap
                font: {
                  family: "Plus Jakarta Sans",
                  weight: 600,
                  size: 16,
                },
              },
            },
            crunch_time: activeLearningPath === 1 && {
              type: "line",
              xMin: crunchTimeLabelFormatted,
              xMax: crunchTimeLabelFormatted,
              yMin: 0,
              yMax: "max",
              borderColor: "rgba(128, 128, 128, 0.5)", // Gray color for Crunch Time
              label: {
                display: true,
                content: "Crunch Time",
                backgroundColor: "rgba(128, 128, 128, 0.5)", // Gray color for Crunch Time
                xAdjust: 30, // Adjust along x-axis to prevent overlap
                yAdjust: -15, // Adjust along y-axis to prevent overlap
                font: {
                  family: "Plus Jakarta Sans",
                  weight: 600,
                  size: 16,
                },
              },
            },
          },
        });
      } else {
        const startingProgress = getStartingProgress() * 100;
        setProjectedProgress({
          fill: [
            {
              title: "Projected Progress",
              data: projectedProgressData,
              color: "#7B7B7B",
              borderDash: [20, 20], // Add the dashed line style
            },
            {
              title: "Projected Progress with Quizzy+",
              data: projectedProgressQuizzyPlusData,
              color: "#8358E8",
              borderDash: [20, 20], // Add the dashed line style
            },
          ],
          labels: dateRange,
          annotations: {
            test_date: {
              type: "line",
              xMin: testDateLabelFormatted,
              xMax: testDateLabelFormatted,
              yMin: startingProgress,
              yMax: "max",
              backgroundColor: "rgba(255, 91, 145, 0.5)",
              borderColor: "rgba(255, 91, 145, 0.5)", // Red color for Test Date
              label: {
                display: true,
                content: `Test Date`,
                backgroundColor: "rgba(255, 91, 145, 0.5)",
                xAdjust: -30, // Adjust along x-axis to prevent overlap
                yAdjust: 15, // Adjust along y-axis to prevent overlap
                font: {
                  family: "Plus Jakarta Sans",
                  weight: 600,
                  size: 16,
                },
              },
            },
            ...(learningPhase === "learning"
              ? {
                  learning: {
                    type: "box",
                    xMin: `${startDate.getMonth() + 1}/${startDate.getDate()}`,
                    xMax: learningEndLabelFormatted,
                    yMin: 0,
                    yMax: "max",
                    backgroundColor: "rgba(88, 232, 146, 0.5)",
                    label: {
                      display: true,
                      content: "Learning",
                      color: "white",
                      backgroundColor: "rgba(88, 232, 146, 0.5)",
                      font: {
                        family: "Plus Jakarta Sans",
                        weight: 600,
                        size: 16,
                      },
                    },
                  },
                }
              : {}),
          },
        });
      }
      setDaysTo100(daysTo100);
      setDaysTo100QuizzyPlus(
        calculateDaysTo100WithMaxSpeed(totalTerms, maxTermsPerDay)
      );
    }
  }, [
    testDate,
    learningSpeed,
    totalTerms,
    activeLearningPath,
    scheduleReadyPopup,
  ]);

  useEffect(() => {
    if (customSchedulePopupEnabled) {
      setTestDatePopupEnabled(true);
      setLearningPathPopup(false);
      setHowOftenPopup(false);
    }
  }, [customSchedulePopupEnabled]);

  return (
    customSchedulePopupEnabled && (
      <>
        <FoldedPopup
          noImage={true}
          closeButton={true}
          enabled={testDatePopupEnabled}
          setEnabled={(enabled) => {
            setCustomSchedulePopupEnabled(enabled);
            setTestDatePopupEnabled(enabled);
          }}
          className="test-schedule-popup2"
        >
          <h1>Enter your Test Date</h1>
          <p>
            Enter your Test Date for this set below, and we'll prepare you to
            get a good grade on it.
          </p>
          <input
            type="date"
            className="add-test-date-picker"
            min={minimumDaysBeforeTestISO}
            defaultValue={minimumDaysBeforeTestISO}
            onChange={(e) => {
              setTestDate(e.target.value);
            }}
          ></input>
          <CTAButton
            text="Continue"
            color="purple"
            onClick={() => {
              setTestDatePopupEnabled(false);
              setLearningPathPopup(true);
            }}
          ></CTAButton>
          <p
            className="no-thanks"
            onClick={() => {
              setCustomSchedulePopupEnabled(false);
            }}
          >
            I don't have a Test Date.
          </p>
        </FoldedPopup>
        <FoldedPopup
          noImage={true}
          closeButton={true}
          enabled={learningPathPopup}
          setEnabled={(enabled) => {
            setCustomSchedulePopupEnabled(enabled);
            setLearningPathPopup(enabled);
          }}
          className="learning-path-popup"
          rightSideContents={
            <>
              <h1 className="title">Projected Progress</h1>
              <p className="caption">
                This is how your learning may look like.
              </p>
              <div className="projected-progress-chart">
                <MultipleLineChart config={projectedProgress} />
              </div>
            </>
          }
        >
          <h1 className="how-often-header">Choose your learning path</h1>
          <p className="based-on-learning">
            A better learning plan will increase your chances of learning
            everything in time.
          </p>
          <div className="learning-plans-cover">
            <div
              className="learning-plan-button"
              active={activeLearningPath === 0 ? "1" : "0"}
              onClick={() => {
                setActiveLearningPath(0);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38.843"
                height="38.89"
                viewBox="0 0 38.843 38.89"
              >
                <path
                  id="edit_square_FILL0_wght400_GRAD0_opsz48"
                  d="M122.815-802.11a2.7,2.7,0,0,1-1.97-.844,2.7,2.7,0,0,1-.844-1.97v-28.147a2.7,2.7,0,0,1,.844-1.97,2.7,2.7,0,0,1,1.97-.844h19L139-833.072H122.815v28.147h28.147V-821.25l2.815-2.815v19.14a2.7,2.7,0,0,1-.844,1.97,2.7,2.7,0,0,1-1.97.844ZM136.888-819Zm8.538-16.513,2.017,1.97-13.37,13.323v4.034h3.987L151.478-829.6l1.97,1.97-14.214,14.261h-7.975v-7.975Zm8.022,7.881-8.022-7.881,4.691-4.691a2.694,2.694,0,0,1,1.985-.8,2.675,2.675,0,0,1,2,.844l3.941,3.987a2.806,2.806,0,0,1,.8,1.992,2.583,2.583,0,0,1-.844,1.948Z"
                  transform="translate(-120 841)"
                  fill="#fff"
                />
              </svg>
              <h1>Basic</h1>
              <p>Quizzy will schedule items for you.</p>
            </div>
            <div
              className="learning-plan-button"
              ref={superLearningPathButton}
              active={activeLearningPath === 1 ? "1" : "0"}
              disabled={user.membership <= 2}
              onClick={() => {
                if (user.membership > 2) {
                  setActiveLearningPath(1);
                }
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="51.85"
                height="41.974"
                viewBox="0 0 51.85 41.974"
              >
                <path
                  id="ambient_screen_FILL0_wght400_GRAD0_opsz48"
                  d="M83.7-760.5a3.553,3.553,0,0,1-2.592-1.111A3.553,3.553,0,0,1,80-764.2v-32.1a3.553,3.553,0,0,1,1.111-2.592A3.553,3.553,0,0,1,83.7-800h41.974a3.553,3.553,0,0,1,2.592,1.111,3.553,3.553,0,0,1,1.111,2.592v18.641h-3.7V-796.3H83.7v32.1h28.517v3.7Zm40.122,2.469-2.592-5.432-5.432-2.592,5.432-2.592,2.592-5.432,2.592,5.432,5.432,2.592-5.432,2.592ZM83.7-764.2v0Zm20.987-7.654,2.592-5.8,5.8-2.592-5.8-2.593-2.592-5.8-2.592,5.8-5.8,2.593,5.8,2.592Z"
                  transform="translate(-80 800)"
                  fill="#fff"
                />
              </svg>
              <div className="super-plan">
                <h1>Super</h1>
                <PlusIcon></PlusIcon>
              </div>

              <p>
                Quizzy will optimize your studying according to your learning
                pace to bring you the best results.
              </p>
            </div>
          </div>

          {user.membership < 3 ? (
            <>
              <WhiteButton
                text="Confirm"
                onClick={() => {
                  if (activeLearningPath === 0) {
                    setLearningPathPopup(false);
                    setHowOftenPopup(true);
                  }
                }}
              ></WhiteButton>
            </>
          ) : (
            <>
              <CTAButton
                text="Confirm"
                color="purple"
                onClick={() => {
                  setLearningPathPopup(false);
                  setHowOftenPopup(true);
                }}
              ></CTAButton>
            </>
          )}

          {user.membership < 3 ? (
            <>
              <p style={{ color: "#8358E8", fontWeight: 600 }}>
                Unlock the Super learning path with Quizzy+ Premium.
              </p>
              <CTAButton
                text="Upgrade"
                color="purple"
                onClick={() => {
                  window.location.href = "/upgrade";
                }}
              ></CTAButton>
            </>
          ) : (
            <></>
          )}
        </FoldedPopup>
        <FoldedPopup
          noImage={false}
          closeButton={true}
          enabled={howOftenPopup}
          setEnabled={(enabled) => {
            setCustomSchedulePopupEnabled(enabled);
            setHowOftenPopup(enabled);
          }}
          className="how-popup2"
          rightSideContents={
            <>
              <h1 className="title">Projected Progress</h1>
              <p className="caption">
                This is how your learning may look like.
              </p>
              <div className="projected-progress-chart">
                <MultipleLineChart config={projectedProgress} />
              </div>
            </>
          }
        >
          <h1 className="how-often-header">
            {/*How often do you want to review these terms?*/}
            How fast do you want to learn these terms?
          </h1>
          <div className="center">
            <div className="slider">
              <a className="slider-label">
                {oftenSliderLabel === "Lightning fast" ? (
                  <span className="lightning-fast-text">
                    {oftenSliderLabel}
                  </span>
                ) : (
                  oftenSliderLabel
                )}{" "}
                {(oftenSliderLabel === "Fast" ||
                  oftenSliderLabel === "Lightning fast") && (
                  <PlusIcon style={{ marginLeft: "10px" }} />
                )}
              </a>
              <ThemeProvider theme={theme}>
                <Slider
                  color="primary"
                  value={oftenSliderValue}
                  step={null}
                  marks={marks}
                  valueLabelDisplay="off"
                  getAriaValueText={() => {
                    return false;
                  }}
                  sx={{
                    "& .MuiSlider-track": {
                      height: "10px",
                    },
                    "& .MuiSlider-rail": {
                      height: "10px",
                      background: "#C8C8C8",
                      opacity: 1,
                    },
                    "& .MuiSlider-thumbColorPrimary": {
                      background: "white",
                      filter: "drop-shadow(0px 0px 15px rgba(0, 0, 0, 16%))",
                      width: "26px",
                      height: "26px",
                      boxShadow: "none",
                      "::before": {
                        boxShadow: "none",
                      },
                    },
                  }}
                  onChange={function (e, x) {
                    if (x === 0) {
                      setOftenSliderLabel("Slow");
                      setLearningSpeed(1);
                    } else if (x === 33) {
                      setOftenSliderLabel("Moderate");
                      setLearningSpeed(2);
                    } else if (x === 66) {
                      setOftenSliderLabel("Fast");
                      setLearningSpeed(3);
                    } else if (x === 100) {
                      setOftenSliderLabel("Lightning fast");
                      setLearningSpeed(4);
                    }
                    setOftenSliderValue(x);
                  }}
                />
              </ThemeProvider>
            </div>
          </div>
          <p className="based-on-learning">
            Based on your learning speed, it may take{" "}
            <span
              style={{ color: "#8358E8", fontWeight: 600, fontSize: "20px" }}
            >
              {daysTo100}
            </span>{" "}
            days to master all terms.
          </p>
          {user.membership < 3 ? (
            <>
              <WhiteButton
                text="Confirm"
                disabled={user.membership < 1 && learningSpeed > 2}
                onClick={() => {
                  if (learningSpeed > 2 && user.membership < 1) {
                    return false;
                  }
                  setHowOftenPopup(false);
                  setScheduleReadyPopup(true);
                  create_study_plan(
                    setid,
                    {
                      test_date: testDate,
                      often_value: learningSpeed - 1,
                      learning_style: activeLearningPath,
                    },
                    (data) => {}
                  );
                }}
              ></WhiteButton>
            </>
          ) : (
            <>
              <CTAButton
                text="Confirm"
                color="purple"
                onClick={() => {
                  setHowOftenPopup(false);
                  setScheduleReadyPopup(true);
                  ReactGA.event({
                    category: "User",
                    action: "Create Study Plan",
                    label: "Created Study Plan",
                  });
                  create_study_plan(
                    setid,
                    {
                      test_date: testDate,
                      often_value: learningSpeed,
                      learning_style: activeLearningPath,
                    },
                    (data) => {}
                  );
                }}
              ></CTAButton>
            </>
          )}

          {user.membership < 3 ? (
            <>
              <p style={{ color: "#8358E8", fontWeight: 600 }}>
                You could master them all in just{" "}
                <span
                  style={{
                    color: "#8358E8",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                >
                  {daysTo100QuizzyPlus}
                </span>{" "}
                days with Quizzy+ Basic.
              </p>
              <CTAButton
                text="Upgrade"
                color="purple"
                onClick={() => {
                  ReactGA.event({
                    category: "User",
                    action: "Clicked Upgrade",
                    label: "Clicked from Study Plan",
                  });
                  window.location.href = "/upgrade";
                }}
              ></CTAButton>
            </>
          ) : (
            <>
              <p style={{ color: "#8358E8", fontWeight: 700 }}>
                As part of your Quizzy+ membership, you can review the terms
                more often to get your desired results faster.
              </p>
            </>
          )}
        </FoldedPopup>
        <FoldedPopup
          noImage={false}
          closeButton={true}
          enabled={scheduleReadyPopup}
          setEnabled={setScheduleReadyPopup}
          className="how-popup2"
          rightSideContents={
            <>
              <h1 className="title">Projected Progress</h1>
              <p className="caption">
                This is how your learning may look like.
              </p>
              <div className="projected-progress-chart">
                <MultipleLineChart config={projectedProgress} />
              </div>
            </>
          }
        >
          <h1 className="how-often-header">Your schedule is ready!</h1>
          <p className="based-on-learning">{getEndText()}</p>
          <div className="schedule-items">
            <ScheduleItem
              title={props.title}
              type="Recall Session"
              time="now"
              onClick={() => {
                navigate("/recall");
              }}
            ></ScheduleItem>
            {activeLearningPath === 1 && (
              <ScheduleItem
                title={props.title}
                type="Quiz"
                time="in 2 days"
              ></ScheduleItem>
            )}
          </div>
          <CTAButton
            text="Finish"
            color="purple"
            onClick={() => {
              window.location.reload();
            }}
          ></CTAButton>
        </FoldedPopup>
      </>
    )
  );
}

export default CustomSchedulePopup;
